import React from "react";
import styled from "styled-components";
import { pxToRem } from "@input-output-hk/px-to-rem";

const StyledExpandImageButton = styled.button`
  height: ${pxToRem(35)};
  width: ${pxToRem(35)};
  padding: 0;
  margin: 0;
  background: transparent;
  border: 0;
`;

const Svg = styled.svg`
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
`;

export const ExpandImageButton = ({
  onClick,
  className
}: React.HTMLProps<HTMLButtonElement>) => (
  <StyledExpandImageButton
    onClick={onClick}
    className={className}
    title="expandImageButton"
  >
    <Svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.5" cy="17.5" r="17.5" fill="#2353FF" />
      <path
        d="M14.451 20.4925L9.90388 25.0396L9.90388 21.4793L8.50058 21.4842L8.50058 27.4346L14.451 27.4346L14.451 26.0363L10.8956 26.0313L15.4427 21.4842L14.451 20.4925Z"
        fill="white"
      />
      <path
        d="M21.1942 21.1439L25.7413 25.691L22.181 25.691L22.1859 27.0943L28.1363 27.0943L28.1363 21.1439H26.738L26.733 24.6992L22.1859 20.1522L21.1942 21.1439Z"
        fill="white"
      />
      <path
        d="M21.8449 15.1024L26.392 10.5553L26.392 14.1156L27.7953 14.1107L27.7953 8.16031L21.8449 8.16031L21.8449 9.55865L25.4003 9.56361L20.8532 14.1107L21.8449 15.1024Z"
        fill="white"
      />
      <path
        d="M15.1036 14.451L10.5566 9.90394L14.1169 9.90394L14.1119 8.50064L8.16153 8.50064L8.16153 14.451H9.55987L9.56483 10.8957L14.1119 15.4427L15.1036 14.451Z"
        fill="white"
      />
    </Svg>
  </StyledExpandImageButton>
);
